export default __webpack_public_path__ + "static/media/About-Us.7ef9d8a2.jpg";